/**
 * Formats an array for PostgreSQL JSON storage
 * @param arr Array to format
 */
export const formatArrayForPostgres = (arr: any[]): string => {
  if (!Array.isArray(arr)) return '[]'; // Return empty JSON array string if not an array
  return JSON.stringify(arr.filter(Boolean)); // Filter out falsy values and stringify
};

/**
 * Cleans metric values to ensure they are valid numbers
 * @param value Value to clean
 */
export const cleanMetricValue = (value: string | number): number => {
  if (typeof value === 'string') {
    // Remove non-numeric characters except decimal point and negative sign
    const cleaned = value.replace(/[^0-9.-]/g, '');
    return parseFloat(cleaned);
  }
  // Ensure number type is returned
  return parseFloat(value.toString());
};

/**
 * Formats a number as a percentage string
 * @param value Number to format as percentage
 * @param decimals Number of decimal places
 */
export const formatPercentage = (value: number, decimals: number = 1): string => {
  return `${(value * 100).toFixed(decimals)}%`;
};

/**
 * Formats a date value to a readable string
 * @param date Date to format
 * @param format Format style (short, medium, long)
 */
export const formatDate = (date: Date | string, format: 'short' | 'medium' | 'long' = 'medium'): string => {
  const dateObj = typeof date === 'string' ? new Date(date) : date;

  const options: Intl.DateTimeFormatOptions =
    format === 'short' ? { month: 'numeric', day: 'numeric', year: '2-digit' } :
    format === 'long' ? { month: 'long', day: 'numeric', year: 'numeric' } :
    { month: 'short', day: 'numeric', year: 'numeric' };

  return new Intl.DateTimeFormat('en-US', options).format(dateObj);
};